var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMethodMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 24,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 17.0993C15.8159 18.0973 14.28 18.6998 12.6017 18.6998C8.85683 18.6998 5.82101 15.7001 5.82101 11.9998C5.82101 8.2995 8.85683 5.2998 12.6017 5.2998C14.28 5.2998 15.8159 5.9023 17 6.90035C18.184 5.9023 19.72 5.2998 21.3983 5.2998C25.1431 5.2998 28.179 8.2995 28.179 11.9998C28.179 15.7001 25.1431 18.6998 21.3983 18.6998C19.72 18.6998 18.184 18.0973 17 17.0993Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 17.0993C18.4579 15.8704 19.3824 14.0418 19.3824 11.9998C19.3824 9.95785 18.4579 8.12925 17 6.90034C18.184 5.9023 19.72 5.2998 21.3983 5.2998C25.1432 5.2998 28.179 8.2995 28.179 11.9998C28.179 15.7001 25.1432 18.6998 21.3983 18.6998C19.72 18.6998 18.184 18.0973 17 17.0993Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 17.0993C18.4579 15.8704 19.3824 14.0418 19.3824 11.9998C19.3824 9.95789 18.4579 8.12929 17 6.90039C15.5421 8.12929 14.6176 9.95789 14.6176 11.9998C14.6176 14.0418 15.5421 15.8704 17 17.0993Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodMasterCard);
export default __webpack_public_path__ + "static/media/payment-method-master-card.5a02e1b423ea6fcd5442601d22f6aa1a.svg";
export { ForwardRef as ReactComponent };